import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LOGO_URL = '/ciaolead-logo-full.png';

/*
 * CL-LEGAL-IMPRESSUM-001 — Public legal notice (reachable without login, route: /impressum).
 *
 * The German text below is the owner-approved wording, reproduced verbatim (only headings and
 * line breaks are visual). Do not translate it or add to it without a new owner approval.
 */
const Impressum = () => {
  return (
    <div className="min-h-screen bg-[var(--bg-page)] world-stars" data-testid="impressum-page">
      <div className="relative z-10 max-w-3xl mx-auto px-5 py-10 sm:px-8 sm:py-14">
        {/* Lightweight standalone header — no app sidebar/chrome */}
        <div className="flex items-center justify-between mb-8">
          <img src={LOGO_URL} alt="CiaoLead" className="h-10 w-auto object-contain" />
          <Link
            to="/login"
            className="inline-flex items-center gap-1.5 text-sm text-blue-400 hover:text-blue-300"
            data-testid="impressum-back-link"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to sign in
          </Link>
        </div>

        <article lang="de" className="world-card p-6 sm:p-10 text-slate-300 leading-relaxed space-y-6"
          data-testid="impressum-content">
          <h1 className="text-3xl font-bold text-white">Impressum</h1>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-white">Angaben gemäß § 5 DDG</h2>
            <p>
              Michele Vincenzoni
              <br />
              Echo Maik Studio
              <br />
              Prenzlauer Allee 7
              <br />
              10405 Berlin
              <br />
              Deutschland
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-white">Kontakt</h2>
            <p>
              Telefon:{' '}
              <a href="tel:+4917664074292" className="text-blue-400 hover:text-blue-300">+49 176 64074292</a>
              <br />
              E-Mail:{' '}
              <a href="mailto:hello@echomaikstudio.com" className="text-blue-400 hover:text-blue-300 break-all">
                hello@echomaikstudio.com
              </a>
            </p>
          </section>

          <section className="space-y-2">
            <p>
              Wirtschafts-Identifikationsnummer gemäß § 139c AO:{' '}
              <span className="whitespace-nowrap">DE465633154-00001</span>
            </p>
          </section>
        </article>
      </div>
    </div>
  );
};

export default Impressum;
